import { Action } from '../actions/emergency-history';

const defaultState = {
  isFetchingEmergencyStatus: false,
  byStationId: {},
};

export default function emergencyHistoryReducer(state = defaultState, action) {
  switch (action?.type) {
    case Action.Station.EmergencyStatusPending:
      return {
        ...state,
        isFetchingEmergencyStatus: true,
      };

    case Action.Station.EmergencyStatusCompleted:
      return {
        ...state,
        isFetchingEmergencyStatus: false,
        byStationId: {
          ...state.byStationId,
          [action.payload.stationId]: action.payload.history,
        },
      };

    case Action.Station.EmergencyStatusFailed:
      return {
        ...state,
        isFetchingEmergencyStatus: false,
        error: true,
        errorMessage: action.payload.error,
      };

    default:
      return state;
  }
}
